import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MailingAddressComponent } from './mailing-address/mailing-address.component';
import { ChangePasswordComponent } from './change-password/change-password.component';


const routes: Routes = [
  { path: '', component: HomeComponent,data: { activeClass: 'settings',title:"Register - Provider Portal" } },
  { path: 'changepassword', component: ChangePasswordComponent },
  { path: 'mailingaddress', component: MailingAddressComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
